import { OutlineEntity } from "@shapeable/types";
import { sortBy } from "lodash";

export const sortConnectedTrends = (items: OutlineEntity[]) => {
  return sortBy(items, item => {
    return item.outlineNumber.split('.').map(Number);
  });
}